import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const submitGuess = createAsyncThunk(
    'guess/submitGuess',
    async ({ answer, bonusEntries }, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/contest/guess', {
                answer,
                bonusEntries
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const guessSlice = createSlice({
    name: 'guess',
    initialState: {
        isSubmitting: false,
        error: null,
        lastSubmission: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(submitGuess.pending, (state) => {
                state.isSubmitting = true;
                state.error = null;
            })
            .addCase(submitGuess.fulfilled, (state, action) => {
                state.isSubmitting = false;
                state.lastSubmission = action.payload;
            })
            .addCase(submitGuess.rejected, (state, action) => {
                state.isSubmitting = false;
                state.error = action.payload;
            });
    }
});

export default guessSlice.reducer; 